import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  AppBar,
  Toolbar,
  Tabs,
  Tab,
  CircularProgress,
} from "@mui/material";
import { Email, Phone, HelpOutline } from "@mui/icons-material";
import colors from "../constants/colors";
import { URL as API_URL } from "../constants/url";

const HelpSupport = () => {
  const [adminDetails, setAdminDetails] = useState({
    email: "",
    phone: ""
  });
  const [loading, setLoading] = useState(true);

  // Fetch admin contact details
  const fetchAdminDetails = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/users/admin-contact-details`);
      const data = await response.json();

      if (data.success) {
        setAdminDetails({
          email: data.email || "onlinekrushimarket@gmail.com",
          phone: data.phone || "+919420777369"
        });
      } else {
        // Set default values on error
        setAdminDetails({
          email: "onlinekrushimarket@gmail.com",
          phone: "+919420777369"
        });
      }
    } catch (err) {
      console.error("Error fetching admin details:", err);
      // Set default values on error
      setAdminDetails({
        email: "onlinekrushimarket@gmail.com",
        phone: "+919420777369"
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdminDetails();
  }, []);

   return (
    <Box sx={{
        height: "100vh", // ADD THIS
        display: "flex",
        flexDirection: "column",
        overflow: "hidden", // ADD THIS
      }}
    >
      {/* Header with Tabs - EXACTLY AS YOUR ORIGINAL */}
      <AppBar
        position="sticky"
        sx={{
          bgcolor: "white",
          color: colors.darkBlack,
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        }}
      >
        <Toolbar
          sx={{
            justifyContent: "space-between",
            gap: 2,
            alignItems: "center",
            minHeight: "64px !important",
            px: { xs: 2, sm: 3 },
          }}
        >
          {/* Single Tab for Help & Support */}
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              overflow: "hidden",
              mr: 2,
            }}
          >
            <Tabs
              value={0}
              sx={{
                minHeight: "48px",
                "& .MuiTabs-indicator": {
                  backgroundColor: colors.green,
                  height: 3,
                  borderRadius: 3,
                },
                "& .MuiTab-root": {
                  fontWeight: 600,
                  textTransform: "none",
                  fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
                  minWidth: "auto",
                  px: { xs: 1, sm: 3 },
                  minHeight: "48px",
                  whiteSpace: "nowrap",
                },
                "& .MuiTab-root.Mui-selected": {
                  color: colors.green,
                },
              }}
            >
              <Tab
                icon={
                  <HelpOutline
                    sx={{ mr: 1, fontSize: { xs: "18px", sm: "20px" } }}
                  />
                }
                iconPosition="start"
                label="Help & Support"
              />
            </Tabs>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Content - EXACTLY AS YOUR ORIGINAL FORMAT */}
      <Box sx={{ p: 3, maxWidth: 800, margin: '0 auto' }}>
        {/* Contact Support Card */}
        <Card sx={{ mb: 4, borderRadius: 3, backgroundColor: colors.lightMint }}>
          <CardContent sx={{ textAlign: 'center' }}>
            <Email sx={{ fontSize: 48, color: colors.green, mb: 2 }} />
            <Typography variant="h5" sx={{ mb: 2, color: colors.darkGreen }}>
              Contact Support
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Can't find what you're looking for? Our support team is here to help you.
            </Typography>
            
            {loading ? (
              <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                justifyContent: 'center', 
                py: 4 
              }}>
                <CircularProgress sx={{ color: colors.green, mb: 2 }} />
                <Typography variant="body2" sx={{ color: colors.midGray }}>
                  Loading contact details...
                </Typography>
              </Box>
            ) : (
              <Box sx={{ textAlign: 'center', mb: 3 }}>
                {/* Email */}
                <Typography variant="body2" sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  mb: 2 
                }}>
                  <Email sx={{ fontSize: 18, mr: 1, color: colors.green }} />
                  <strong>Email:</strong> &nbsp;{adminDetails.email}
                </Typography>
                
                {/* Phone */}
                <Typography variant="body2" sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  mb: 2 
                }}>
                  <Phone sx={{ fontSize: 18, mr: 1, color: colors.green }} />
                  <strong>Phone:</strong> &nbsp;{adminDetails.phone}
                </Typography>
                
                {/* Hours - Keep hardcoded as in original */}
                <Typography variant="body2" sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center' 
                }}>
                  <span style={{ marginRight: '8px' }}>🕒</span>
                  <strong>Hours:</strong> &nbsp;Mon-Sun, 8AM-8PM
                </Typography>
              </Box>
            )}
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default HelpSupport;